module.exports = __webpack_public_path__ + "88a422be5f46b0f826fd3b9a0ff6b3f7.svg";